import * as React from 'react';
import { FormCard } from '@qbe/ads-blocks-forms';
import { useContentContext } from '@qbe/dfc-content';
import { useContentComplaintPartners } from 'utils/content';

const InternalErrorMessage = () => {
  const { getTextContent } = useContentComplaintPartners({ context: useContentContext() });

  return (
    <FormCard
      variant="pageTitle"
      title={getTextContent('internalErrorMessage.title')}
      description={getTextContent('internalErrorMessage.description')}
    />
  );
};

export default InternalErrorMessage;
